import './i18n';

import ReactDOM from 'react-dom';

import App from './App';
import { initialiseTelemetry } from './telemetry/appInsights';

// Initialise Application Insights browser telemetry before the first render
// so the initial page view and any startup errors are captured. The call is
// a no-op when no connection string is configured (local/dev default).
initialiseTelemetry();

ReactDOM.render(<App />, document.getElementById('root'));

// Enable HMR for development
// https://www.snowpack.dev/tutorials/react#making-snowpack-even-faster-with-fast-refresh
// Webpack should strip this out
/* if (import.meta.hot) {
  import.meta.hot.accept();
}
 */
